<ul class="root" *ngIf="data">
    <accordion-item-block *ngFor="let item of data.items.value" [data]="item"></accordion-item-block>
</ul>
